import { m } from 'motion/react';
import {
  containerVariants,
  itemVariants,
  viewPort,
} from '../../../utils/framer';
import KIAImage from './image/KIAImage';

interface TextOnImgProps {
  image: string;
  altText?: string;
  title?: string;
  subtitle?: string;
  position?: 'top' | 'bottom';
  hAlign?: 'left' | 'center';
  titleClass?: string;
  subtitleClass?: string;
  className?: string;
}

const TextOnImg = ({
  image,
  altText = '',
  title,
  subtitle,
  position = 'bottom',
  hAlign = 'center',
  titleClass = 'text-3xl sm:text-4xl lg:text-5xl font-bold',
  subtitleClass = 'text-base sm:text-lg lg:text-xl font-light',
  className = '',
}: TextOnImgProps) => {
  const posClass =
    position === 'top'
      ? 'top-4 sm:top-6 md:top-8 lg:top-12'
      : 'bottom-4 sm:bottom-6 md:bottom-8 lg:bottom-12';
  const hClass =
    hAlign === 'left'
      ? 'left-2 sm:left-4 md:left-8 lg:left-12 -translate-x-0 text-left'
      : 'left-1/2 -translate-x-1/2 text-center';

  return (
    <div
      className={`relative w-full aspect-video overflow-hidden ${className}`}
    >
      <KIAImage
        src={image}
        alt={altText}
        className="absolute inset-0 w-full h-full object-cover"
        sizes="100vw"
      />

      {(title || subtitle) && (
        <m.div
          initial="hidden"
          whileInView="visible"
          variants={containerVariants}
          viewport={viewPort}
          className={`absolute ${hClass} ${posClass} px-0 md:px-4 space-y-2 text-white`}
        >
          {title && (
            <m.h2
              variants={itemVariants}
              className={`whitespace-pre-line break-normal hyphens-none leading-[1.1] ${titleClass}`}
            >
              {title}
            </m.h2>
          )}
          {subtitle && (
            <m.p
              variants={itemVariants}
              className={`whitespace-pre-line leading-[1] ${subtitleClass}`}
            >
              {subtitle}
            </m.p>
          )}
        </m.div>
      )}
    </div>
  );
};

export default TextOnImg;
